module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ntsx-page"
    }
  }, [_c('div', {
    staticClass: "header-wrap"
  }, [_c('header', {
    staticClass: "public-head-layout wrapper"
  }, [_c('div', {
    staticClass: "site-logo index_logo"
  }, [_c('img', {
    staticClass: "pngFix",
    attrs: {
      "src": _vm.logoImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-user-menu"
  }, [_c('img', {
    staticClass: "theadicon",
    attrs: {
      "src": _vm.theadiconImg
    }
  }), _vm._v(" "), _c('dl', {
    directives: [{
      name: "handle-hover",
      rawName: "v-handle-hover"
    }],
    staticClass: "my-cart"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cCheckout.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.theadcartImg
    }
  })]), _vm._v(" "), _c('dd', {
    staticClass: "my-cart-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "incart-goods-box"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartNums === 0),
      expression: "cartNums === 0"
    }],
    staticStyle: {
      "text-align": "center",
      "border": "0px!important"
    }
  }, [_vm._v("您的菜篮中还没有任何商品\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "incart-goods"
  }, _vm._l((_vm.cartProducts), function(item, index) {
    return _c('dl', {
      key: index,
      staticClass: "item"
    }, [_c('dd', {
      staticClass: "goods-thumb"
    }, [_c('span', {
      staticClass: "thumb size40"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "title": item.name,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.imageDefault,
        "alt": "item.name",
        "height": "40",
        "width": "40"
      }
    })])], 1)]), _vm._v(" "), _c('dt', {
      staticClass: "goods-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "title": item.name,
        "target": "_blank"
      }
    }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                    ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "goods-price"
    }, [_c('p', [_vm._v("￥" + _vm._s(item.couponPrice) + "×" + _vm._s(item.num))])]), _vm._v(" "), _c('dd', {
      staticClass: "handle"
    }, [_c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.cDeleteCart(item.goodsId)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartNums > 0),
      expression: "cartNums > 0"
    }],
    staticClass: "checkout"
  }, [_c('a', {
    staticClass: "btn-cart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cCheckout.apply(null, arguments)
      }
    }
  }, [_vm._v("结算菜篮中的商品")])])])])])])])]), _vm._v(" "), _c('Affix', [_c('nav', {
    staticClass: "public-nav-layout"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('ul', {
    staticClass: "site-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/3"
    }
  }, [_vm._v("地方特产")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/117"
    }
  }, [_vm._v("生鲜果蔬")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/18"
    }
  }, [_vm._v("粮油调味")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/8"
    }
  }, [_vm._v("休闲食品")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/1"
    }
  }, [_vm._v("名酒冲调")])], 1)])])])]), _vm._v(" "), _c('nav', {
    staticClass: "public-nav-side",
    attrs: {
      "id": "public-nav-side"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/3"
    }
  }, [_vm._v("地方特产")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/117"
    }
  }, [_vm._v("生鲜果蔬")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/18"
    }
  }, [_vm._v("粮油调味")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/8"
    }
  }, [_vm._v("休闲食品")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural/1"
    }
  }, [_vm._v("名酒冲调")])], 1)])]), _vm._v(" "), _c('banner', {
    attrs: {
      "data": _vm.banners
    }
  }), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-title"
  }, [_c('h4', [_vm._v("最新加入的商品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe3c320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fresh-agricultural/index.vue
// module id = 1646
// module chunks = 1